import {gql} from "@apollo/client";

export const POST_JOB_STEP = gql`
	mutation postJobStep ($input: PostJobStepInput!) {
		postJobStep(input: $input) {
			jobStep {
				id
			}
		}
	}
`;
